/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import { Header, SideMenu, Select, Button } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton, ButtonTable } from './styles';
import { loadingColor, primary } from 'styles/colorProvider';
import { BiPencil, BiTrash } from 'react-icons/bi';
import { AiFillCheckCircle, AiFillCloseCircle } from 'react-icons/ai';

import { renderAddCoverages, renderEditCoverages, renderRemoveCoverages } from './modals';
import { handleLoadMore, loadData } from './requests';
import { useMediaQuery } from '../../../../../node_modules/@material-ui/core/index';
import { DEFAULT_COVERAGES_INFO_VALUES } from 'utils/backofficeValues';

// import { dataColumns } from './helper';

function BackOfficeProductsBlockCoverages({ history }) {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingDataTable, setLoadingDataTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState();
  const [selectStatus, setSelectStatus] = useState('all');
  const [startData, setStartdata] = useState();
  const [endData, setEndData] = useState();
  const [touchFilter, setTouchFilter] = useState();

  // Modals
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openModalRemove, setOpenModalRemove] = useState(false);

  const [selectedPartnerVendor] = useState('all');

  const [userPartners, setUserPartners] = useState([]);
  const [coverageInfo, setCoverageInfo] = useState(DEFAULT_COVERAGES_INFO_VALUES);
  const [coverageList, setCoverageList] = useState([]);
  const [coverageType, setCoverageType] = useState('basic');

  const coveragesConfig = [
    {
      type: 'basic',
      pricing_id: 'id_pricing_basic_coverage',
      editParams: ['percent', 'enabled'],
    },
    {
      type: 'deductible',
      pricing_id: 'id_pricing_deductible',
      editParams: ['percent', 'type', 'enabled'],
    },
    {
      type: 'fipelmi',
      pricing_id: 'id_pricing_fipe_lmi',
      editParams: ['percent_value', 'enabled'],
    },
    {
      type: 'glass',
      pricing_id: 'id_pricing_glass',
      editParams: ['value', 'enabled'],
    },
    {
      type: 'optional',
      pricing_id: 'id_pricing_optional_coverage',
      editParams: ['value', 'percent', 'enabled'],
    },
    {
      type: 'replacement',
      pricing_id: 'id_pricing_replacement_car',
      editParams: ['value', 'enabled'],
    },
    {
      type: 'support',
      pricing_id: 'id_pricing_support',
      editParams: ['value', 'enabled'],
    },
    {
      type: 'rule',
      pricing_id: 'id_pricing_rule_coverage',
      editParams: ['percent', 'type'],
    },
  ];

  useEffect(() => {
    const loadAllData = async () => {
      // Depois puxa os bloqueios (Array que aparece na tabela)
      await loadData({
        setCurrentPage,
        setCoverageList,
        setHasNextPage,
        setLoading,
        setTotalCount,
        setTouchFilter,
        loadingDataTable,
        setLoadingDataTable,
        coverageType,
      });
    };

    if (coverageType) loadAllData();
  }, [coverageType]);

  const dataColumns = [
    {
      name: 'ID',
      selector: (row) => row?.id,
      width: '7%',
      sortable: true,
    },
    // Change to role
    {
      name: 'Nome',
      selector: (row) => {
        return row?.name;
      },
      width: '25%',
      sortable: true,
    },
    // {
    //   name: 'Parceiro',
    //   selector: (row) => row?.TB_PARTNERS?.trade_name,
    //   width: '28%',
    //   sortable: true,
    // },
    {
      name: 'Regra ativa?',
      selector: (row) =>
        row.enabled ? (
          <AiFillCheckCircle
            size={16}
            style={{
              color: '#62ec83',
            }}
          />
        ) : (
          <AiFillCloseCircle
            size={16}
            style={{
              color: 'red',
            }}
          />
        ),
      width: '12%',
      sortable: true,
    },
    {
      name: 'Editar',
      selector: (row) => (
        <ButtonTable
          onClick={() => {
            setCoverageInfo({
              ...coverageInfo,
              id: row.id,
              percent: row?.percent,
              enabled: row?.enabled,
              percent_value: row?.percent_value,
              value: row?.value,
              type: row?.type,
            });
            setOpenModalEdit(true);
          }}
        >
          <BiPencil size={16} />
        </ButtonTable>
      ),
      width: '8%',
      sortable: false,
    },
    {
      name: 'Excluir',
      selector: (row) => (
        <ButtonTable
          onClick={() => {
            setCoverageInfo({
              ...coverageInfo,
              id: row.id,
            });
            setOpenModalRemove(true);
          }}
        >
          <BiTrash size={16} />
        </ButtonTable>
      ),
      width: '8%',
      sortable: false,
    },
  ];

  const matches = useMediaQuery('(min-width:1000px)');

  return (
    <>
      <Header />
      <Container>
        {renderRemoveCoverages({
          openModalRemove,
          setOpenModalRemove,
          coverageList,
          setCoverageList,
          loading,
          setLoading,
          setCurrentPage,
          setHasNextPage,
          setTotalCount,
          setTouchFilter,
          setUserPartners,
          loadingDataTable,
          setLoadingDataTable,
          coverageType,
          coverageInfo,
          setCoverageInfo,
        })}
        {renderAddCoverages({
          openModalAdd,
          setOpenModalAdd,
          userPartners,
          coverageInfo,
          setCoverageInfo,
          setLoading,
          loading,
          setCurrentPage,
          setCoverageList,
          setHasNextPage,
          setTotalCount,
          setTouchFilter,
          setUserPartners,
          loadingDataTable,
          setLoadingDataTable,
          coverageType,
          coverageList,
          coveragesConfig,
        })}
        {renderEditCoverages({
          openModalEdit,
          setOpenModalEdit,
          coverageInfo,
          setCoverageInfo,
          loading,
          setLoading,
          loadData,
          setCurrentPage,
          setCoverageList,
          setHasNextPage,
          setTotalCount,
          setTouchFilter,
          loadingDataTable,
          setLoadingDataTable,
          coverageType,
          coveragesConfig,
        })}
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>COBERTURAS</Title>

            <div
              style={{
                display: 'flex',
                flexDirection: matches ? 'row' : 'column',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  marginBottom: matches ? '26px' : 0,
                  width: '100%',
                }}
              >
                <Select
                  height="30px"
                  label="Tipo de cobertura"
                  value={coverageType}
                  onChange={(e) => setCoverageType(e.target.value)}
                >
                  <option value={'basic'}>Básica</option>
                  <option value={'deductible'}>Dedutível</option>
                  <option value={'fipelmi'}>FIPE LMI</option>
                  <option value={'glass'}>Vidro</option>
                  <option value={'optional'}>Opcional</option>
                  <option value={'replacement'}>Reposição</option>
                  <option value={'support'}>Suporte</option>
                  <option value={'rule'}>Regra</option>
                </Select>
              </div>

              <Button
                title="Adicionar"
                height="30px"
                onClick={() => setOpenModalAdd(true)}
                disabled={loading || loadingDataTable || coverageType === 'basic'}
              >
                Adicionar
              </Button>

              {/* <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData({
                    setCurrentPage,
                    setBlockCoverageList,
                    setHasNextPage,
                    setLoading,
                    setTotalCount,
                    setTouchFilter,
                    search,
                    loadingDataTable,
                    setLoadingDataTable,
                    coverageType,
                  });
                }}
                onConfirm={() =>
                  loadData({
                    setCurrentPage,
                    setBlockCoverageList,
                    setHasNextPage,
                    setLoading,
                    setTotalCount,
                    setTouchFilter,
                    search,
                    loadingDataTable,
                    setLoadingDataTable,
                    coverageType,
                  })
                }
              /> */}
            </div>
          </Div>
          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={() => {
                handleLoadMore({
                  touchFilter,
                  search,
                  startData,
                  endData,
                  selectStatus,
                  selectedPartnerVendor,
                  currentPage,
                  hasNextPage,
                  loadingMore,
                  setLoadingMore,
                  coverageList,
                  setCurrentPage,
                  setCoverageList,
                  setHasNextPage,
                  coverageType,
                });
              }}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={0}
            >
              <DataTable
                // onRowClicked={(row) => history.push(`/backoffice/detalhes-da-proposta/${row?.id}`)}
                persistTableHead
                responsive
                columns={dataColumns}
                data={coverageList}
                highlightOnHover
                pointerOnHover
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading || loadingDataTable}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhum bloqueio encontrado</small>}
              />
            </InfiniteScroll>
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {coverageList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default BackOfficeProductsBlockCoverages;
